import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { BrandIcon } from '@jotta/ui/BrandIcon'
import type { ButtonProps } from '@jotta/ui/Button'
import { Button } from '@jotta/ui/Button'
import * as Popover from '@radix-ui/react-popover'
import SvgSmiley from '@jotta/ui/SvgSmiley'

export interface EmojiPickerProps {
  disabled?: boolean
  onSelect: (emoji: any) => void
  onOpenChange?: (open: boolean) => void
}

export const EmojiPicker: React.FC<EmojiPickerProps & Partial<ButtonProps>> = ({
  disabled = false,
  onSelect = () => {},
  onOpenChange,
  ...props
}) => {
  return (
    <Popover.Root onOpenChange={onOpenChange}>
      <Popover.Trigger asChild>
        <Button
          variant="buttons.text"
          disabled={disabled}
          sx={{
            height: 'auto',
            flex: '0 0 auto',
            opacity: 0.6,
            ':disabled': {
              opacity: 0.4,
            },
            ':hover:not(:disabled)': {
              opacity: 1,
            },
            ':focus': {
              color: 'unset',
            },
          }}
          {...props}
        >
          <BrandIcon
            icon={SvgSmiley}
            width={24}
            height={24}
            sx={{ display: 'block' }}
          />
        </Button>
      </Popover.Trigger>
      <Popover.Content>
        <Picker
          data={data}
          theme="light"
          autoFocus
          maxFrequentRows={0}
          onEmojiSelect={onSelect}
        />
      </Popover.Content>
    </Popover.Root>
  )
}
